import Image from "next/image";
import styles from "./Header.module.scss";

export const Header = function () {
  return (
    <div className={styles.headerImage}>
      <Image
        src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/02/53674fac-harvard-signature-horizontal-ovp-advances-in-learning-rgb-02_0g603g0g603g000000001.png"
        alt="university logo"
        width={305}
        height={65}
      />
    </div>
  );
};
